﻿$.fn.dxCtrlPagePlanitiReunionExterneChoixSaisie = function custom_dxCtrlPagePlanitiReunionExterneChoixSaisie(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexternechoixsaisie dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterneChoixSaisie(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterneChoixSaisie = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxTelReunion = null
    var dxNomStructure = null
    var dxNomPrenom = null
    var dxEmail = null
    var dxAdrPostale = null
    var dxLigneAdresse = null
    var dxCodePostal = null
    var dxVille = null
    var dxSiteWeb = null
    var dxTelFixe = null
    var dxMobile = null
    var dxTagBoxInvite = null
    var dxLieu = null
    var dxTextInfo = null
    var lstFile = []
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        container.css("text-align", "left")


        $("<div style='position:sticky;top:0;left:0;z-index:2;width:40px;'/>").appendTo(container).dxCtrlButton({
            icon: "fas fa-arrow-left",
            hint: "Choisir une autre date ou un autre créneau",
            onClick: function (e) {
                option.onCancel()
            }
        }).dxCtrlButton("instance")

        var $DivContainer = $("<div style='margin:0 5px 0 40px;'/>").appendTo(container)


        var $DivBtValide = $("<div style='margin:0 2px;padding:0 10px 10px 0;text-align:right;position:sticky;top:0;z-index:2;opacity:0.9;color:--dx-color-separator'/>").appendTo($DivContainer)
        $("<div style='text-align:right;'/>").appendTo($DivBtValide).dxCtrlButton({
            text: "Programmer la réunion",
            onClick: function (e) {
                mValideReunion()
            }
        })

        $("<div style='font-weight:bold;font-size:120%;margin-bottom:5px;'>Saisissez vos coordonnées</div>").appendTo($DivContainer)
        option.dataPlaniti.planiti_champ.sort(function (o1, o2) { return o1.tri - o2.tri }).forEach(function (planitiChamp) {
            if (planitiChamp.demander == 1) {
                var champTable = option.bddCtrl.mGetArray("champ_table").filter(function (champTable) { return champTable.id_champ_table == planitiChamp.id_champ_table })[0]
                switch (parseInt(champTable.id_type_champ)) {
                    case 19://nomStructure
                        dxNomStructure = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTextBox({
                            label: "Societé" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            labelMode: 'floating',
                            value: "", //value: "Societesylomallo",
                            onValueChanged: function (e) {

                            }
                        }).dxCtrlTextBox("instance")
                        break;
                    case 18: //nomprenom
                        dxNomPrenom = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Nom & prénom" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            width: "100%",
                            multiline: false,
                            value: "", //value: "Sylo MALLO",
                            onValueChanged: function (e) {
                                //var nomPrenom = new cNomPrenom(option.bddCtrl, e.value)
                                //if (option.value == null) option.value = {}
                                //option.value.nom = nomPrenom.nom
                                //option.value.prenom = nomPrenom.prenom
                                //option.value.id_titre = nomPrenom.id_titre
                                //option.value.sexe = nomPrenom.sexe
                                //option.value.normalise = nomPrenom.normalise
                                //if (typeof option.onValueChanged != 'undefined') option.onValueChanged({ value: option.value })
                            }
                        }).dxCtrlTextBox("instance")
                        break;
                    case 7: //Email
                        dxEmail = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTextEmail({
                            labelMode: "floating",
                            label: "Adresse email" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            bddCtrl: option.bddCtrl,
                            value: "", //value: "testemail@gmail.com"
                        }).dxCtrlTextEmail("instance")
                        break;
                    case 8: //adressepostale
                        dxLigneAdresse = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Adresse",
                            width: "100%",
                            multiline: false,
                            value: "",
                            onValueChanged: function (e) {
                            }
                        }).dxCtrlTextBox("instance")
                        var $Table = $("<table style='width:100%'/>").appendTo($DivContainer)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='min-width:100px;padding-right:5px;'/>").appendTo($Tr)
                        dxCodePostal = $("<div style='margin:3px;'/>").appendTo($Td).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Code postal",
                            width: "100%",
                            multiline: false,
                            value: "",
                            onValueChanged: function (e) {
                            }
                        }).dxCtrlTextBox("instance")
                        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                        dxVille = $("<div style='margin:3px;'/>").appendTo($Td).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Ville",
                            width: "100%",
                            multiline: false,
                            value: "",
                            onValueChanged: function (e) {
                            }
                        }).dxCtrlTextBox("instance")
                        //dxAdrPostale = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlSaisieAdresse({
                        //    labelMode: "floating",
                        //    label: "Adresse postale" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                        //    bddCtrl:option.bddCtrl,
                        //    hideButton: true,
                        //    value: null, //value: JSON.parse('{"ad1":"","ad2":"","ad3":"","cp":"","ville":"Lyon","cedex":"","dpt":"Rhône","region":"Auvergne-Rhône-Alpes","pays":"France","code_pays":"FR","latitude":45.76730728,"longitude":4.83430672,"normalise":1}')
                        //}).dxCtrlSaisieAdresse("instance")
                        break;
                    case 15: //siteweb
                        dxSiteWeb = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Site web" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            bddCtrl: option.bddCtrl,
                            width: "100%",
                            multiline: false,
                            value: "", //value: "https://www.mascaron.eu"
                        }).dxCtrlTextBox("instance")
                        break;
                    case 16: //telfixe
                        dxTelFixe = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTelephone({
                            labelMode: "floating",
                            label: "Téléphone fixe" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            bddCtrl: option.bddCtrl,
                            width: "100%",
                            typeTel: "tel",
                            value: null,
                            disableVerifSaisie:true
                            //value: {
                            //    tel_code_pays: "fr",
                            //    tel_indic_pays: "33",
                            //    tel_number: "0478764355",
                            //    tel_complet: "0478764355",
                            //    tel_sms: "+33478764355",
                            //    tel_error: -1,
                            //    tel_num_type: "-1"
                            //}
                        }).dxCtrlTelephone("instance")
                        break;
                    case 17: //mobile
                        dxMobile = $("<div style='margin:3px;'/>").appendTo($DivContainer).dxCtrlTelephone({
                            labelMode: "floating",
                            label: "Téléphone mobile" + ((planitiChamp.obligatoire == 1) ? " *" : ""),
                            bddCtrl: option.bddCtrl,
                            width: "100%",
                            typeTel: "mob",
                            disableVerifSaisie: true
                            //value: {
                            //    tel_code_pays: "fr",
                            //    tel_indic_pays: "33",
                            //    tel_number: "0671749779",
                            //    tel_complet: "0671749779",
                            //    tel_sms: "+33671749779",
                            //    tel_error: -1,
                            //    tel_num_type: "-1"
                            //}
                        }).dxCtrlTelephone("instance")
                        break;
                }
            }
        })

        if (option.dataPlaniti.planiti.nbre_organisateur == 1) {
            $("<div style='font-weight:bold;font-size:120%;margin:25px 0 5px 0;'>Ajouter des invités</div>").appendTo($DivContainer)
            dxTagBoxInvite = $("<div/>").appendTo($DivContainer).dxTagBox({
                labelMode: 'floating',
                label: "Adresses emails des invités",
                items: [],
                value: [],
                acceptCustomValue: true,
                dropDownOptions: {
                    visible: false,
                    onShowing: function (e) { e.cancel = true }
                },
                onKeyDown: function (e) {
                    if (e.event.key == ";" || e.event.key == ",") {
                        e.component.blur()
                        window.setTimeout(function () { e.component.focus() }, 0)
                    } else {
                        if (e.component.option("value").length > 10) {
                            mNotify("Vous ne pouvez pas saisir plus de 10 adresses emails.", "warning", 6000)
                            e.component.blur()
                            window.setTimeout(function () { e.component.focus() }, 0)
                        }
                    }
                },
                onCustomItemCreating: function (e) {
                    var newValue = e.text;
                    if (newValue != null && newValue.valideEmail() && !e.component.option("value").contains(newValue)) {
                        if (newValue.valideEmail()) {
                            if (!e.component.option("value").contains(newValue)) {
                                e.customItem = newValue;
                            } else {
                                e.customItem = null
                                mNotify("Vous avez déjà saisie cette adresse email", "warning", 6000)
                            }
                        } else {
                            e.customItem = null
                            mNotify("Veuillez saisir une adresse valide", "warning", 6000)
                        }
                    } else {
                        e.customItem = null
                    }
                }
            }).dxTagBox("instance")
            $("<div style='font-style:italic;font-size:80%;opacity:0.5;'>Vous pouvez rajouter jusqu'à 10 invités.</div>").appendTo($DivContainer)
        }

        $("<div style='font-weight:bold;font-size:120%;margin:25px 0 0 0;'>Mode de communication</div>").appendTo($DivContainer)
        var $DivDetailLieu = $("<div style='margin-left:30px;'/>").appendTo($DivContainer)
        dxLieu = $("<div/>").appendTo($DivDetailLieu).dxCtrlRadioGroup({
            dataSource: option.dataPlaniti.planiti_lieu,
            value: option.dataPlaniti.planiti_lieu[0],
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("line-height", "1")
                switch (parseInt(itemData.id_type_lieu)) {
                    case 0:
                        itemElement.html("Téléphone<br/><span style='font-style:italic;opacity:0.5;font-size:80%;'>Nous vous appellerons sur le numéro que vous nous avez fourni à l'heure du rendez-vous.</span>");
                        //dxTelReunion = $("<div style='margin:3px;'/>").appendTo(itemElement).dxCtrlTelephone({
                        //    labelMode: "floating",
                        //    label: "Téléphone où vous joindre pour la réunion *",
                        //    width: "100%",
                        //    typeTel: "mob",
                        //    value: null,
                        //    onValueChanged: function () {  }
                        //}).dxCtrlTelephone("instance")
                        break;
                    case 1:
                        itemElement.html("Vidéo zoom<br/><span style='font-style:italic;opacity:0.5;font-size:80%;'>L'url zoom vous sera fournie à la confirmation de votre rendez-vous.</span>");
                        break;
                }
                window.setTimeout(function () {
                    if (option.dataPlaniti.planiti_lieu[0].id_type_lieu == "0") { dxTelReunion.element().show() }
                    else { dxTelReunion.element().hide() }
                }, 0)
            },
            onValueChanged: function (e) {
                switch (parseInt(e.value.id_type_lieu)) {
                    case 0:
                        if (dxTelReunion) dxTelReunion.element().slideDown(200)
                        break;
                    case 1:
                        if (dxTelReunion) dxTelReunion.element().slideUp(200)
                        break;
                }
            }
        }).dxCtrlRadioGroup("instance")
        dxTelReunion = $("<div style='margin:3px;display:none'/>").appendTo($DivDetailLieu).dxCtrlTelephone({
            labelMode: "floating",
            label: "Téléphone où vous joindre pour la réunion *",
            width: "100%",
            typeTel: "",
            value: null,
            disableVerifSaisie: true,
            onValueChanged: function () { }
        }).dxCtrlTelephone("instance")

        var $Table = $("<table style='margin:25px 0 5px 0;'/>").appendTo($DivContainer)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdAddFile = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
        $("<td style='font-weight:bold;font-size:120%;width:100%'>Partager les informations qui nous permettrons de préparer la réunion</td>").appendTo($Tr)
        var $DivFichier = $("<div/>").appendTo($DivContainer)

        var dxCtrlFichierJoint = $("<div/>").appendTo($DivFichier).dxCtrlFichier2Document({
            bddCtrl: option.bddCtrl,
            dataSource: [],
            readOnly: false,
            containerBtAdd: $TdAddFile,
            imgInternet: false,
            box: false,
            icone: false,
            docCpt: false,
            courrier: false,
            onAdd: function () {
                lstFile = dxCtrlFichierJoint.mGetLstUrlFile()
            },
            onDelete: function (file) {
                lstFile = dxCtrlFichierJoint.mGetLstUrlFile()
            }
        }).dxCtrlFichier2Document("instance")

        //$("<div style='font-weight:bold;font-size:120%;width:100%;margin:25px 0 5px 0;'>Partager les informations qui nous permettrons de préparer la réunion</div>").appendTo($Tr)

        dxTextInfo = $("<div/>").appendTo($DivContainer).dxCtrlTextBox({
            label: "Partager les informations qui nous permettrons de préparer la réunion",
            labelMode: 'hidden',
            multiline: true,
            minHeight: 200,
            value: "",
            onValueChanged: function (e) {
            }
        }).dxCtrlTextBox("instance")

    }

    function mValideReunion() {
        option.jauge.mShow()
        var lstFileSend = []
        lstFile.forEach(function (o) { lstFileSend.push({ path_file: o }) })
        var dataToBeSend = {
            command: "createplanitireunion",
            id_planiti: option.dataPlaniti.planiti.id_planiti,
            date_debut: option.dat,
            date_fin: new Date(option.dat).addMinutes(option.dataPlaniti.planiti.duree_reunion_mn),
            coordonnees: {},
            email_invite: [],
            lst_file: lstFileSend,
            id_planiti_lieu: null,
            text_info: ""
        }
        //Vérif saisie
        var lstCtrlKo = []
        var textKo = ""
        option.dataPlaniti.planiti_champ.sort(function (o1, o2) { return o1.tri - o2.tri }).forEach(function (planitiChamp) {
            if (planitiChamp.demander == 1 && planitiChamp.obligatoire == 1) {
                var champTable = option.bddCtrl.mGetArray("champ_table").filter(function (champTable) { return champTable.id_champ_table == planitiChamp.id_champ_table })[0]
                switch (parseInt(champTable.id_type_champ)) {
                    case 19://nomStructure
                        dxNomStructure.element().find("input").css("background-color", "")
                        if (dxNomStructure.option("value") == null || dxNomStructure.option("value").length == 0) {
                            lstCtrlKo.push(dxNomStructure)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; nom de votre société"
                        }
                        break;
                    case 18: //nomprenom
                        dxNomPrenom.element().find("input").css("background-color", "")
                        if (dxNomPrenom.option("value") == null || dxNomPrenom.option("value").length == 0) {
                            lstCtrlKo.push(dxNomPrenom)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; nom et prénom"
                        }
                        break;
                    case 7: //Email
                        dxEmail.element().find("input").css("background-color", "")
                        if (dxEmail.option("value") == null || dxEmail.option("value").length == 0 || dxEmail.hasHerreur) {
                            lstCtrlKo.push(dxEmail)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; adresse email"
                        }
                        break;
                    case 8: //adressepostale
                        dxLigneAdresse.element().find("input").css("background-color", "")
                        dxCodePostal.element().find("input").css("background-color", "")
                        dxVille.element().find("input").css("background-color", "")
                        if (dxLigneAdresse.option("value") == null || dxLigneAdresse.option("value").length == 0) {
                            lstCtrlKo.push(dxLigneAdresse)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; adresse"
                        }
                        if (dxCodePostal.option("value") == null || dxCodePostal.option("value").length == 0) {
                            lstCtrlKo.push(dxCodePostal)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; code postal"
                        }
                        if (dxVille.option("value") == null || dxVille.option("value").length == 0) {
                            lstCtrlKo.push(dxVille)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; ville"
                        }
                        break;
                    case 15: //siteweb
                        dxSiteWeb.element().find("input").css("background-color", "")
                        if (dxSiteWeb.option("value") == null || dxSiteWeb.option("value").length == 0) {
                            lstCtrlKo.push(dxSiteWeb)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; site web"
                        }
                        break;
                    case 16: //telfixe
                        dxTelFixe.element().find("input").css("background-color", "")
                        if (!dxTelFixe.hasValue()) {
                            lstCtrlKo.push(dxTelFixe)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; téléphone fixe"
                        }
                        break;
                    case 17: //mobile
                        dxMobile.element().find("input").css("background-color", "")
                        if (!dxMobile.hasValue()) {
                            lstCtrlKo.push(dxMobile)
                            textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; téléphone mobile"
                        }
                        break;
                }
            }
        })

        if (dxLieu.option("value").id_type_lieu == "0") {
            //réunion tel
            dxTelReunion.element().find("input").css("background-color", "")
            if (!dxTelReunion.hasValue() || dxTelReunion.option("value").tel_error != "-1") {
                lstCtrlKo.push(dxTelReunion)
                if (!dxTelReunion.hasValue()) {
                    textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; le numéro de téléphone où vous joindre pour la réunion"
                } else {
                    textKo += ((textKo.length > 0) ? "<br/>" : "") + "&bull; Saisir un numéro correcte pour le numéro de téléphone où vous joindre pour la réunion"
                }
            }
        }

        if (textKo.length > 0) {
            lstCtrlKo.forEach(function (dx) { dx.element().find("input").css("background-color", "#800000") })
            mNotify("Veuillez remplir les champs suivants:<br/>" + textKo, "warning", 6000)
            option.dxScroll.scrollToElement(lstCtrlKo[0].element())
            lstCtrlKo[0].focus()
            option.jauge.mHide()
            return
        }


        option.dataPlaniti.planiti_champ.sort(function (o1, o2) { return o1.tri - o2.tri }).forEach(function (planitiChamp) {
            if (planitiChamp.demander == 1) {
                var champTable = option.bddCtrl.mGetArray("champ_table").filter(function (champTable) { return champTable.id_champ_table == planitiChamp.id_champ_table })[0]
                switch (parseInt(champTable.id_type_champ)) {
                    case 19://nomStructure
                        dxNomStructure.element().find("input").css("background-color", "")
                        if (!(dxNomStructure.option("value") == null || dxNomStructure.option("value").length == 0)) {
                            dataToBeSend.coordonnees.nom_societe = dxNomStructure.option("value")
                        }
                        break;
                    case 18: //nomprenom
                        dxNomPrenom.element().find("input").css("background-color", "")
                        if (!(dxNomPrenom.option("value") == null || dxNomPrenom.option("value").length == 0)) {
                            var nomPrenom = new cNomPrenom(option.bddCtrl, dxNomPrenom.option("value"))
                            dataToBeSend.coordonnees.contact = {
                                nom: nomPrenom.nom,
                                prenom: nomPrenom.prenom,
                                id_titre: nomPrenom.id_titre,
                                sexe: nomPrenom.sexe
                            }
                        }
                        break;
                    case 7: //Email
                        dxEmail.element().find("input").css("background-color", "")
                        if (!(dxEmail.option("value") == null || dxEmail.option("value").length == 0 || dxEmail.hasHerreur)) {
                            dataToBeSend.coordonnees.adresse_email = dxEmail.option("value")
                        }
                        break;
                    case 8: //adressepostale
                        dxLigneAdresse.element().find("input").css("background-color", "")
                        dxCodePostal.element().find("input").css("background-color", "")
                        dxVille.element().find("input").css("background-color", "")
                        if (typeof dataToBeSend.coordonnees.adresse_postale == 'undefined') dataToBeSend.coordonnees.adresse_postale = {
                            ad1: '',
                            ad2: '',
                            ad3: '',
                            cp: '',
                            ville: '',
                            cedex: '',
                            dpt: '',
                            region: '',
                            pays: '',
                            code_pays: '',
                            latitude: null,
                            longitude: null,
                            normalise: 1
                        }
                        if (dxLigneAdresse.option("value") == null || dxLigneAdresse.option("value").length == 0) {
                            dataToBeSend.coordonnees.adresse_postale.ad1 = dxLigneAdresse.option("value")
                        }
                        if (dxCodePostal.option("value") == null || dxCodePostal.option("value").length == 0) {
                            dataToBeSend.coordonnees.adresse_postale.cp = dxCodePostal.option("value")
                        }
                        if (dxVille.option("value") == null || dxVille.option("value").length == 0) {
                            dataToBeSend.coordonnees.adresse_postale.ville = dxVille.option("value")
                        }
                        break;
                    case 15: //siteweb
                        dxSiteWeb.element().find("input").css("background-color", "")
                        if (!(dxSiteWeb.option("value") == null || dxSiteWeb.option("value").length == 0)) {
                            dataToBeSend.coordonnees.site_web = dxSiteWeb.option("value")
                        }
                        break;
                    case 16: //telfixe
                        dxTelFixe.element().find("input").css("background-color", "")
                        if (dxTelFixe.hasValue()) {
                            dataToBeSend.coordonnees.tel_fixe = dxTelFixe.option("value")
                        }
                        break;
                    case 17: //mobile
                        dxMobile.element().find("input").css("background-color", "")
                        if (dxMobile.hasValue()) {
                            dataToBeSend.coordonnees.tel_mobile = dxMobile.option("value")
                        }
                        break;
                }
            }
        })


        if (dxTagBoxInvite && dxTagBoxInvite.option("value").length > 0) {
            dxTagBoxInvite.option("value").forEach(function (email) {
                dataToBeSend.email_invite.push({ "adresse_email": email })
            })
        }

        dataToBeSend.id_planiti_lieu = dxLieu.option("value").id_planiti_lieu
        dataToBeSend.tel_sms_appel = ""
        if (dxLieu.option("value").id_type_lieu == "0") dataToBeSend.tel_sms_appel = dxTelReunion.option("value").tel_sms
        dataToBeSend.text_info = dxTextInfo.option("value")

        option.bddCtrl.mAjaxCall(dataToBeSend, function (data) {
            if (data.creneaupris == "1") {
                mNotify("Le créneau que vous avez choisi a été réservé. Veuillez choisir un autre créneau.", "error", 6000)
                option.jauge.mHide()
                option.onCancel()
            } else if (data.ok == "0") {
                mNotify("Impossible de créer le rendez-vous.", "error", 6000)
                option.jauge.mHide()
                option.onCancel()
            } else {
                var idplanitiReunion = data.id_planiti_reunion
                var idPlanitiReunionOrga = data.id_planiti_reunion_orga
                option.onValidateReunion(idplanitiReunion, idPlanitiReunionOrga)
                option.jauge.mHide()
                //option.bddCtrl.mAjaxCall({
                //    command: "getdataplanitireunion", id_planiti_reunion: data.id_planiti_reunion,
                //    id_planiti_reunion_orga: data.id_planiti_reunion_orga
                //}, function (data) {
                //    var html = $("<div/>").dxCtrlPlanitiReunionDetail({
                //        dataPlanitiReunion: data
                //    })[0].outerHTML
                //    option.bddCtrl.mAjaxCall({
                //        command: "savehtmlplanitireunionorga",
                //        id_planiti_reunion_orga: idPlanitiReunionOrga,
                //        html: html
                //    })
                //    option.onValidateReunion(idplanitiReunion, idPlanitiReunionOrga)
                //    option.jauge.mHide()
                //})
            }
        }, null, function () {
            option.jauge.mHide()
        })
    }

    this.element = function () { return container; }

    mConstruit();
}